<h1 class="text-dark text-xl" mat-dialog-title>Cancella fondi cassa</h1>
<div class="w-full" mat-dialog-content>
  <form [formGroup]="deleteForm" class="space-y-4">
    <mat-form-field class="w-full date-picker-white">
      <mat-label>Data</mat-label>
      <input
        [matDatepicker]="picker"
        formControlName="data"
        matInput
        placeholder="DD/MM/YYYY"
        required
      />
      <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error *ngIf="deleteForm.get('data')?.hasError('required')">
        La data è obbligatoria
      </mat-error>
    </mat-form-field>
  </form>
</div>
<div class="flex justify-end gap-2" mat-dialog-actions>
  <button (click)="onCancel()" [disabled]="loading" class="btn btn-secondary" mat-button>
    Annulla
  </button>
  <button
    (click)="onDelete()"
    [disabled]="deleteForm.invalid || loading"
    class="btn btn-danger"
    mat-button
  >
    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-2"></span>
    Cancella
  </button>
</div>
